var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import * as ServiceActivite from '../../services/activite';
import { EditionActivite } from './EditionActivite';
import { Link } from '../../utils/Link';
import { Table } from '../../utils/Table';
import { Typography } from '../../utils/Typography';
import { ContactIcon, CollaborateurIcon, ClientIcon, ActiviteIcon, CloseIcon, CommentaireIcon, } from '../../utils/Icons';
import { IconButton } from '../../utils/IconButton';
import { Chip, Tooltip } from '@mui/material';
import moment from 'moment';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { colorEtatActivite } from '../../utils/Classes';
import { getOriginalUser } from '../../services/utilisateur';
var originalUser = getOriginalUser();
export var Activite = function (props) {
    var _a = props.withFiltre, withFiltre = _a === void 0 ? false : _a, _b = props.ClientId, ClientId = _b === void 0 ? null : _b, _c = props.CollaborateurId, CollaborateurId = _c === void 0 ? null : _c;
    var _d = useState([]), activites = _d[0], setActivites = _d[1];
    var _e = useState(0), total = _e[0], setTotal = _e[1];
    var getData = function (_a) {
        var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.itemByPage, itemByPage = _c === void 0 ? 10 : _c, _d = _a.filtres, filtres = _d === void 0 ? null : _d, _e = _a.order, order = _e === void 0 ? null : _e;
        return __awaiter(void 0, void 0, void 0, function () {
            var _f, Activites, Total, error_1;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ServiceActivite.getActiviteListe(ClientId, CollaborateurId, {
                                page: page,
                                itemByPage: itemByPage,
                                filtres: filtres,
                                order: order,
                            })];
                    case 1:
                        _f = _g.sent(), Activites = _f.Activites, Total = _f.Total;
                        setActivites(Activites);
                        setTotal(Total);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _g.sent();
                        setActivites([]);
                        setTotal(0);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var handleClickDelete = function (activiteId, refresh) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ConfirmDialog({
                        title: 'Suppression',
                        content: 'Êtes-vous sûr de vouloir supprimer cette activité ?',
                        color: 'error',
                    })];
                case 1:
                    confirmation = _a.sent();
                    if (!confirmation.isOk) return [3 /*break*/, 3];
                    return [4 /*yield*/, ServiceActivite.deleteActivite(activiteId)];
                case 2:
                    _a.sent();
                    refresh();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var displayClientPro = activites.filter(function (c) { return c.IsSociete; }).length > 0;
    return (_jsx(_Fragment, { children: _jsx(Table, { title: !ClientId && !CollaborateurId ? 'Activites' : '', color: "activite", canEdit: true, canAdd: !!ClientId, renderModalEdition: function (handleClose, _a) {
                var _b = _a.ActiviteId, ActiviteId = _b === void 0 ? null : _b, _c = _a.ActiviteClientId, ActiviteClientId = _c === void 0 ? null : _c;
                return (_jsx(EditionActivite, { ClientId: ActiviteClientId ? ActiviteClientId : ClientId, ActiviteId: ActiviteId, handleClose: function () { return handleClose(); } }));
            }, onExport: originalUser.CanExportActivite
                ? function (filtres) {
                    return ServiceActivite.exportActivite(ClientId, CollaborateurId, filtres);
                }
                : null, typeFiltre: withFiltre ? 'Activite' : null, refresh: getData, total: total, isResponsive: true, headers: __spreadArray(__spreadArray([
                {
                    label: 'Type',
                    component: function (value, _a) {
                        var handleUpdate = _a.handleUpdate, color = _a.color;
                        return (_jsx(_Fragment, { children: _jsx(Link, { title: value.activite_type.Libelle, color: color, to: "/", onClick: function (e) {
                                    e.preventDefault();
                                    handleUpdate({
                                        ActiviteId: value.IdActivite,
                                        ActiviteClientId: value.ClientId,
                                    });
                                }, icon: _jsx(ActiviteIcon, {}), bold: true }) }));
                    },
                    orderBy: 'ActiviteTypeId',
                },
                {
                    label: 'État',
                    align: 'center',
                    minWidth: true,
                    component: function (value) { return (_jsx(Chip, { color: colorEtatActivite(value.Etat), label: value.getEtatLibelle })); },
                    orderBy: 'Etat',
                },
                {
                    label: 'Résultat',
                    align: 'center',
                    minWidth: true,
                    component: function (value) {
                        return value.Resultat && (_jsx(Chip, { color: colorEtatActivite(value.Resultat), label: value.getResultatLibelle }));
                    },
                    orderBy: 'Resultat',
                }
            ], (!ClientId
                ? __spreadArray([
                    {
                        label: 'Client',
                        component: function (value) {
                            return value.client ? (_jsx(Link, { title: value.client.getLibelle, color: "client", to: '/client/fiche/' + value.client.IdClient, icon: _jsx(ClientIcon, {}) })) : ('-');
                        },
                    }
                ], (displayClientPro
                    ? [{ label: 'Siret', assessor: 'Siret', orderBy: 'Siret' }]
                    : []), true) : []), true), [
                {
                    label: 'Collaborateur',
                    component: function (value) {
                        return value.activite__collaborateurs &&
                            value.activite__collaborateurs.map(function (value) {
                                return value.collaborateur && (_jsx(Link, { title: value.collaborateur.getLibelle, color: "collaborateur", to: '/collaborateur/fiche/' +
                                        value.collaborateur.IdCollaborateur, icon: _jsx(CollaborateurIcon, {}) }, value.collaborateur.IdCollaborateur));
                            });
                    },
                },
                {
                    label: 'Début',
                    align: 'right',
                    minWidth: true,
                    component: function (value) {
                        return value.DateDebut
                            ? moment(value.DateDebut).format('DD/MM/YYYY HH:mm')
                            : '';
                    },
                    orderBy: 'DateDebut',
                },
                {
                    label: 'Fin',
                    align: 'right',
                    minWidth: true,
                    component: function (value) {
                        return value.DateFin
                            ? moment(value.DateFin).format('DD/MM/YYYY HH:mm')
                            : '';
                    },
                    orderBy: 'DateFin',
                },
                {
                    label: 'Contacts',
                    component: function (value) {
                        return value.activite__contacts &&
                            value.activite__contacts.map(function (c) {
                                return (c.contact && (_jsx(Typography, __assign({ variant: "body1", startIcon: _jsx(ContactIcon, {}) }, { children: c.contact.getLibelle }), c.IdActiviteContact)));
                            });
                    },
                },
                {
                    align: 'right',
                    component: function (value) { return (_jsx(_Fragment, { children: value.Commentaire && (_jsx(Tooltip, __assign({ disableInteractive: true, title: value.Commentaire }, { children: _jsx(CommentaireIcon, {}) }))) })); },
                },
                {
                    align: 'right',
                    component: function (value, _a) {
                        var refresh = _a.refresh;
                        return (_jsx(_Fragment, { children: _jsx(IconButton, __assign({ color: "error", tooltip: "Supprimer", onClick: function () { return handleClickDelete(value.IdActivite, refresh); } }, { children: _jsx(CloseIcon, {}) })) }));
                    },
                },
            ], false), datas: activites ? activites : [] }) }));
};
//# sourceMappingURL=Activite.js.map